<template>
    <div class="personTypeSelection" :class="{ 'selection-made': modelValue && !autoAdvance }">
        <template v-if="!modelValue || autoAdvance">
            <div 
                class="personTypeSelection_card" 
                @click="selectType('NATURAL')"
            >
                <div class="personTypeSelection_card_icon">
                    <sw-icon name="user" />
                </div>
                <div class="personTypeSelection_card_title">Pessoa Física</div>
                <div class="personTypeSelection_card_description">Para seus arquivos pessoais.</div>
            </div>
            <div 
                class="personTypeSelection_card" 
                @click="selectType('COMPANY')"
            >
                <div class="personTypeSelection_card_icon">
                    <sw-icon name="briefcase" />
                </div>
                <div class="personTypeSelection_card_title">Pessoa Jurídica</div>
                <div class="personTypeSelection_card_description">Para arquivos da sua empresa.</div>
            </div>
        </template>
        <template v-else>
            <div class="personTypeSelection_selected">
                <div class="personTypeSelection_change_selection">
                    <sw-button 
                        name="Alterar"
                        color="gray"
                        size="sm"
                        @click="resetSelection"
                    />
                </div>
                <div class="personTypeSelection_selected_info">
                    <div class="personTypeSelection_selected_icon">
                        <sw-icon :name="modelValue === 'NATURAL' ? 'user' : 'briefcase'" />
                    </div>
                    <div class="personTypeSelection_selected_title">{{ modelValue === 'NATURAL' ? 'Pessoa Física' : 'Pessoa Jurídica' }}</div>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
	defineProps({
		modelValue: String,
		autoAdvance: {
			type: Boolean,
			default: false
		}
	});

	const emit = defineEmits(['update:modelValue']);

	const selectType = (type) => {
		emit('update:modelValue', type);
	};

    const resetSelection = () => {
        emit('update:modelValue', '');
    };
</script>

<style lang="scss" scoped>
.personTypeSelection {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5em;
    margin-bottom: 2em;
    transition: all 0.3s ease;
}

.personTypeSelection.selection-made {
    grid-template-columns: 1fr;
}

.personTypeSelection_card {
    position: relative;
    padding: 2em 1.5em;
    border: 2px solid var(--borderColorLight, #e5e7eb);
    border-radius: 1em;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: center;
    background: linear-gradient(145deg, var(--backgroundCard), #ffffff);
    overflow: hidden;

    &:hover {
        transform: translateY(-4px);
        box-shadow: var(--boxShadowMedium, 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06));
        border-color: var(--linkColor, #3b82f6);
    }
}

/* Responsividade usando mixins do projeto */
@import '@/assets/css/mediaScreen.scss';

@include screen_medias(s, m) {
    .personTypeSelection {
        grid-template-columns: 1fr;
        gap: 1em;
    }
}

.personTypeSelection_card_icon {
    width: 4em;
    height: 4em;
    margin: 0 auto 1em;
    border-radius: 50%;
    background-color: var(--backgroundHover, #f1f5f9);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
    color: var(--textMuted, #64748b);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.personTypeSelection_card_title {
    font-size: 1.125em;
    font-weight: 600;
    color: var(--textPrimary, #1e293b);
    transition: all 0.3s ease;
    margin-bottom: 0.25em;
}

.personTypeSelection_card_description {
    font-size: 0.875em;
    color: var(--textSecondary, #475569);
    line-height: 1.5;
}

.personTypeSelection_selected {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1em 1.5em;
    border: 2px solid var(--linkColor, #3b82f6);
    border-radius: 1em;
    background: linear-gradient(145deg, #f0f5ff, #ffffff);
}

.personTypeSelection_selected_info {
    display: flex;
    align-items: center;
    gap: 1em;
}

.personTypeSelection_selected_icon {
    width: 2.5em;
    height: 2.5em;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--linkColor, #3b82f6), var(--colorBlueDark100, #1e40af));
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
}

.personTypeSelection_selected_title {
    font-size: 1.125em;
    font-weight: 700;
    color: var(--linkColor, #3b82f6);
}

.personTypeSelection_change_selection {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
